import React, { useState, useEffect } from 'react'
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import InputField from '../../../../CommonComponents/InputMUI'
import {
    getMailTemplateCountApi, getMailTemplateConfigApi,
    getWhatsappTemplateCountApi, getWhatsappTemplateConfigApi,
    getTextMsgTemplateCountApi, getTextMsgTemplateConfigApi,
    CommunityLeadCommunicationApi
} from './CommActionCreator'
import AlertUi from '../../../../Popups/SidePopup'
import Loader from '../../../../../../../presentationals/Loader/Loader.component'
import SelectField from '../../../../CommonComponents/SelectMUI'
const receiverdataCommunity = [
    { code: 'LENDER', name: 'Lender' },
    { code: 'USER', name: 'User' },
]
const receiverdataLenders = [
    { code: 'COMMUNITY', name: 'Community' },
    { code: 'USER', name: 'User' },
]
const receiverdataAdmin = [
    { code: 'LENDER', name: 'Lender' },
    { code: 'COMMUNITY', name: 'Community' },
    { code: 'USER', name: 'User' },
]
const DetailMainPage = ({ rowData, viewScreen, loginType }) => {
    const [templates, setTemplates] = useState([]) 
    const [alertPopupState, setalertPopupState] = useState(false)
    const [msg, setmsg] = useState()
    const [loaderState, setloaderState] = useState(false)
    const [validationMsg, setValidationmsg] = useState()

    const [objectData, setObjectData] = useState({
        subject: '',
        body: '',
        type: '',
        mobileNo: '',
        emailId: '',
        senderName: '',
        templateId: '',
        senderId: '',
        senderType: '',
        recieverType: '',
        recieverId: '',
        fromAddress: '',
        isHTML: false,
        userId:rowData.userId,
        loanId:rowData.loanId
    })
    const [templateActive,setTemplateActive]=useState('')

    useEffect(() => {
        getTemplatesHandler()
        let changeObjectData = Object.assign({}, objectData)
        changeObjectData.subject = ''
        changeObjectData.body = ''
        changeObjectData.type = viewScreen
        changeObjectData.mobileNo = rowData.mobileNo
        changeObjectData.emailId = rowData.emailId
        changeObjectData.senderName = ''
        changeObjectData.templateId = ''
        changeObjectData.senderId = window.sessionStorage.getItem(loginType === 'COMMUNITY' ? 'communityId' : loginType === 'LENDER' ? 'lenderId' : 'userId')
        changeObjectData.senderType = loginType
        changeObjectData.recieverType = ''
        changeObjectData.recieverId = ''
        changeObjectData.fromAddress = window.sessionStorage.getItem('emailId')
        changeObjectData.isHTML = false
        setObjectData(changeObjectData)
    }, [viewScreen])

    const getTemplatesHandler = () => {
        const searchInput = {
            type: loginType,
            licenseId: window.sessionStorage.getItem('licenseId'),
        }
        if (viewScreen === 'mail') {
            setloaderState(true)
            getMailTemplateCountApi(searchInput, count => {
                getMailTemplateConfigApi(1, count, searchInput, callBack => {
                    setTemplates(callBack)
                    setloaderState(false)
                }, error => {

                })
            }, error => {

            })
        } else if (viewScreen === 'whatsapp') {
            setloaderState(true)
            getWhatsappTemplateCountApi(searchInput, count => {
                getWhatsappTemplateConfigApi(1, count, searchInput, callBack => {
                    setTemplates(callBack)
                    setloaderState(false)
                }, error => {

                })
            }, error => {

            })
        } else if (viewScreen === 'txtmsg') {
            setloaderState(true)
            getTextMsgTemplateCountApi(searchInput, count => {
                getTextMsgTemplateConfigApi(1, count, searchInput, callBack => {
                    setTemplates(callBack)
                    setloaderState(false)
                }, error => {

                })
            }, error => {

            })
        }
    }

    const inputChange = (e, type) => {
        let changeObjectData = Object.assign({}, objectData)
        if (type === 'templateId') {
            changeObjectData[type] = e.target.value
            let filteredTemplate = templates.filter(x => x.templateId === e.target.value)

            if (filteredTemplate.length > 0) {
                changeObjectData.body = filteredTemplate.body !== undefined ? filteredTemplate.body : ''
                changeObjectData.subject = filteredTemplate.subject !== undefined ? filteredTemplate.subject : ''
                changeObjectData.senderName = filteredTemplate.senderId !== undefined ? filteredTemplate.senderId : ''
            }
        } else if (type === 'body') {
            changeObjectData[type] = e.target.value
        } else {
            changeObjectData[type] = e
        }
        setObjectData(changeObjectData)
    }

    const sendHandler = () => {
        if (objectData.recieverId && objectData.recieverType && objectData.subject && objectData.body) {
            setloaderState(true)

            CommunityLeadCommunicationApi(objectData, callBack => {
                setValidationmsg('')
                if (callBack === 'success') {
                    setloaderState(false)

                    setalertPopupState(true)
                    setmsg('Successfully sent!')
                    removePopup()
                } else {
                    setloaderState(false)
                    setalertPopupState(true)
                    setmsg('Please try again later!')
                    removePopup()
                }
            }, error => {

            })
        } else {
            setValidationmsg('Enter All details!')
        }
    }
    const sendToHandler = (e) => {
        let changeObjectData = Object.assign({}, objectData)
        changeObjectData.recieverType = e
        changeObjectData.recieverId = e === 'LENDER' ? rowData.lenderId : e === 'USER' ? rowData.userId : e==='COMMUNITY'?rowData.communityId:''
        setObjectData(changeObjectData)

    }
    const removePopup = () => {
        setTimeout(
            function () {
                setalertPopupState(false)
            }.bind(this),
            5000
        );
    }
    const templatehandler =(e,data)=>{
        let changeObjectData = Object.assign({}, objectData)
        changeObjectData.body = data.body !== undefined ? data.body : ''
        changeObjectData.subject = data.subject !== undefined ? data.subject : ''
        changeObjectData.senderName = data.senderId !== undefined ? data.senderId : ''
        setTemplateActive(data.templateName)
        setObjectData(changeObjectData)
    }
    return (
        <div className='container-fluid full-height'>
            {loaderState ?
                <Loader />
                : ""}
            {alertPopupState ?
                <AlertUi msg={msg} />
                : ""}
            <div className='row'>
                <div className='col-sm-4 col-xs-12'>
                    <SelectField
                        label={'Send To'}
                        onChange={e => sendToHandler(e)}
                        value={objectData.recieverType}
                        data={ window.location.href.includes('lender')?receiverdataLenders:window.location.href.includes('community')?receiverdataCommunity: window.location.href.includes('admin') ?receiverdataAdmin:""}
                        size={'small'}
                        required={true}
                    />
                </div>
                <div className='col-sm-4 col-xs-12'>

                </div>

            </div>
            <div className='row'>
                <h3 className='' style={{ marginTop: '20px',marginLeft:'20px',fontWeight:'400' }}>Templates</h3>
                {templates.map((data, i) => {
                    return (

                        <div className='col-sm-3 col-xs-12' onClick={(e)=>templatehandler(e,data)} style={{marginBottom:'20px'}}>
                            {console.log(typeof(data.templateName))}
                            <input className='card button-templates' value={data.templateId !== undefined ? data.templateId : ''} style={{ display: 'none' }} />
                            <b className={templateActive===data.templateName ?'card button-templates':'card button-templates-active'} style={{display:'inline-block',width:'100%',borderRadius:"0"}}> {data.templateName !== undefined ? data.templateName : ''}</b>
                        </div>
                    )
                })}
                {/* {templates.length > 0 ?
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            name="radio-buttons-group"
                            value={objectData.templateId}
                            onChange={e => inputChange(e, 'templateId')}
                        >
                            {templates.map((data, i) => {
                                return (
                                    <div style={{ marginBottom: i === 0 ? '-23px' : '' }}>
                                        <FormControlLabel key={i} value={data.templateName !== undefined ? data.templateName : ''} control={<Radio size='small' />} label={<span style={{ fontSize: '14px' }}>{data.templateName !== undefined ? data.templateName : ''}</span>} />
                                    </div>
                                )
                            })}
                        </RadioGroup>
                        : null} */}
                {/* </div> */}
            </div>
            <div className='row'>
                <div className='col-sm-8 col-xs-12'>
                    <h5 className='mt-2'><b>{viewScreen === 'txtmsg' ? 'Text Messages' : viewScreen === 'whatsapp' ? 'Whats App' : viewScreen === 'mail' ? 'Mail' : ""}</b></h5>
                    {viewScreen === 'mail' ?
                        <>
                            <InputField
                                label="Subject"
                                variant="outlined"
                                value={objectData.subject}
                                name="subject"
                                id="subject"
                                type="text"
                                onChange={e => inputChange(e, 'subject')}
                                size="small"
                            />
                            <br />
                            <br />
                        </>
                        : null}
                    <textarea style={{ minHeight: '150px',border:'1px solid #dee2e6',background:'#fff' }} className='form-control form-group' value={objectData.body} onChange={e => inputChange(e, 'body')}></textarea>
                    <h5 className='text-danger text-center'>{validationMsg}</h5>
                    <div className='mb-3 row'>
                        <div className="col-12 text-center">
                            <button className="cred-btn" onClick={e => sendHandler()}>Send</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DetailMainPage;
